<template>
  <div class="hold">
    <div class="row">
      <div v-if="doneLoading">
        <h5 style="color: green;">{{ subject && subject.name }} Test</h5>
        <br>
        <h6>Test Instructions:</h6>
        <p>You have <b>{{ testDuration }}</b> to complete the test, during which you won't be allowed to pause or leave the test screen. When you have completed the practice exam, you can click on the submit button at the bottom of the test screen. Your results would be updated automatically. <br><b>Good Luck!</b></p>
        <button class="btn btn-success submit-button mx ignore" @click="startTest">Start Test</button>
      </div>
      <div v-else class="row justify-content-center">
        <div class="text-center col">
          <spinner />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import swal from 'sweetalert';
import Spinner from "@/components/Preloaders/Spinner";

const API = `${BASE_API}/v1`;

export default {
  props: ['abilitySubject'],
  components: {
    Spinner,
  },
  data() {
    return {
      doneLoading: false,
    };
  },
  beforeCreate() {
    if (this.$store.getters.subjects && this.$store.getters.subjects.length === 0) {
      this.$store.dispatch('getSubjects');
    }
  },
  mounted() {
    console.log('   mounted   ');
    if (typeof this.abilitySubject !== 'undefined') {
      this.$store.dispatch('getSubjectTest', { abilitySubject: this.abilitySubject })
        .then(response => this.doneLoading = true)
        .catch((error) => {
          if (error.data && error.data.status) {
            return (
              swal(error.data.status, error.data.message, 'error')
                .then(value => value && this.$router.push({ name: 'test-status' }))
            );
          }
          return (
            swal('error', 'something went wrong', 'error')
              .then(value => value && this.$router.push({ name: 'test-status' }))
          );
        });
    };
  },
  computed: {
    subject() {
      return this.test.ability_subject && this.test.ability_subject.subject;
    },
    test() {
      return this.$store.getters.active_test;
    },
    testDuration() {
      return moment.duration(this.test.duration, 'seconds').humanize();
    },
  },
  methods: {
    activeChild(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => this.$route.path.indexOf(path) >= 0);
    },
    startTest() {
      return swal({
        title: 'Are you sure',
        text: 'Please note that this test gives you the opportunity to write it for 3 trials, at the end of the 3rd trial you will have to wait 3months from the date you wrote the last test to try again. Once you start the test you must finish it. You need to have acces to good Internet, pen and paper to start a test. If you do not finish before the time is up, your test is automatically submitted and scored',
        icon: 'warning',
        buttons: ['Cancel', 'Start ➜'],
      }).then((value) => {
        if (value) {
          axios.get(`${API}/tutor/tests/${this.abilitySubject}/${this.test.id}/start`)
            .then((response) => {
              this.$store.dispatch('startCountdown', response.data.time_left);
              this.$store.commit('SET_TEST_SUBJECT', this.abilitySubject);
              const isdash = this.$route.path.indexOf('dashboard') >= 0;
              return this.$router.push({ name: 'test', params: { test: this.test.id }, query: { dashboard: isdash } });
            })
            .catch(({response:{data}}) => {

              swal({type:'error', text: data && data.message})
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .hold {margin: 25px;}
  .card {
    padding: 40px;
    margin-top: 10px;
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(150,150,150,0.14), 0 3px 1px -2px rgba(150,150,150,0.12), 0 1px 5px 0 rgba(150,150,150,0.2);
  }
  h6 {font-size: 18px; font-weight: bold;}
  p {width: 100%; max-width: 550px;}
  button {
    height: 40px;
    width: 140px;
    line-height: 40px;
    padding: 0 10px;
    text-transform: uppercase;
    background-color: #639440;
    color: #fff;
    font-weight: 300;
  }
.submit-button {
  width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &.btn-default {
    box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14), 0 3px 1px -2px rgba(112, 112, 112, 0.12), 0 1px 5px 0 rgba(112, 112, 112, 0.2);
  }
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
  .row { margin: 0; margin-bottom: 20px; }
  @media only screen and (max-width: 600px) {
  .hold {margin-bottom: 35px; margin-top: 20px;}
  .title {font-size: 16px;}
  .ase {padding: 10px; margin-bottom: 25px; h5 {font-size: 14px;}}
  table.table-borderless {font-size: 10px !important;}
  .submit-button:not(.ignore) {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    float: left;
    left: 0;
    border-radius: 0;
    text-transform: uppercase;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Test/TakeTest.vue